enum CaptchaAction {
  CreateAccount = 'create_account',
  SignIn = 'sign_in',
}

export default CaptchaAction;
